"use client";

import { Show, UserButton as ClerkUserButton, useUser } from "@clerk/react";
import { Stack, type SxProps, type Theme } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { type FC } from "react";

import { PlanGiftIcon } from "~/components/AppBar/PlanGiftIcon";
import { AppSignInButton } from "~/feature/auth/components/AppSignInButton/AppSignInButton";
import { AppSignUpButton } from "~/feature/auth/components/AppSignUpButton";

const authButtonSx: SxProps<Theme> = {
  minWidth: 0,
  textTransform: "none",
  borderRadius: 999,
  whiteSpace: "nowrap",
};

export const UserButton: FC = () => {
  const { isLoaded } = useUser();

  return (
    <Box>
      <Show when="signed-in">
        <ClerkUserButton />
        <PlanGiftIcon sx={{ marginLeft: "10px" }} />
      </Show>
      {!isLoaded && <CircularProgress size={20} />}
      <Show when="signed-out">
        <Stack
          sx={{
            flexDirection: "row",
            gap: 0.5
          }}>
          <AppSignInButton sx={authButtonSx} />
          <AppSignUpButton sx={authButtonSx} />
        </Stack>
      </Show>
    </Box>
  );
};
